/*
  Magnum colour names to colours.

  One shared list of every colour name in the shop and the colour to show for
  it, used by the ink picker on product pages and by the quick-add popup on
  collection pages. Keeping it in one file means a colour only has to be
  corrected once.

  TO EDIT A COLOUR: change its hex code in INK_COLOURS below. Names are matched
  loosely (case, spaces and hyphens are ignored), so "Leaf Green", "leaf-green"
  and "Leaf Green " all find the same entry. A name that is not listed is
  worked out from the colour words inside it ("Deep Sea Blue"), and anything
  left over has no colour of its own.

  Use it as MagnumColours.hexFor('Leaf Green').
*/
(function () {
  'use strict';
  /*
    Every ink colour we know, name to colour.

    Most of these were read straight off each ink's own photo on the site - the
    colour splash behind the bottle - so they are the real ink colour rather
    than a guess from the name. A name that is not listed here falls back to the
    colour words below.

    TO EDIT A COLOUR: change its hex code here. Names are matched loosely (case,
    spaces and hyphens are ignored).
  */
  var INK_COLOURS = {
    "10%": "#d8d0c0",
    // Practice skin tones, read off the Oink Fitzpatrick photos.
    "Fitzpatrick 1": "#e6d7c6",
    "Fitzpatrick 2": "#e0caae",
    "Fitzpatrick 3": "#d9a987",
    "Fitzpatrick 4": "#ba8560",
    "Fitzpatrick 5": "#91562e",
    "Fitzpatrick 6": "#614533",
    // The pack of all six shows all six, as slices of the dot.
    "Fitzpatrick 1-6 (Pack of 6)":
      "conic-gradient(#e6d7c6 0 60deg, #e0caae 0 120deg, #d9a987 0 180deg, #ba8560 0 240deg, #91562e 0 300deg, #614533 0)",
    "150 Vampy": "#481800",
    "165 Maroon": "#702018",
    "180 Lipstick": "#801010",
    "185 Sundried Tomato": "#b83018",
    "20%": "#a8a090",
    "200 Wild Pink": "#800008",
    "205 Crushed Berries": "#a03848",
    "210 Rose Pink": "#b04058",
    "235 Light Peony": "#b05848",
    "30%": "#706850",
    "50%": "#383020",
    "Acropolis Orange": "#f87008",
    "Algae": "#687858",
    "Alizarin Crimson 06": "#684048",
    "All Mighty Mind": "#c08060",
    "Almond": "#c0b088",
    "Americano Cream": "#a87050",
    "Amsterdam Purple": "#302850",
    "Animated Peach": "#f8c088",
    "Anime Flesh": "#d8b080",
    "Anime Flesh Dark": "#b88058",
    "Anonymous": "#686050",
    "Antique Fuchsia": "#603068",
    "Apple Green": "#308000",
    "Aquamarine": "#106880",
    "Arctic Dark": "#6878c0",
    "Artichoke": "#b09820",
    "Ash Brown": "#605848",
    "Ash Coffee": "#706050",
    "Atlantis": "#60b8b8",
    "Atmospheric Dark": "#584868",
    "Atmospheric Light": "#9098b0",
    "Atmospheric Medium": "#7878a8",
    "Atomic Yellow": "#f8e030",
    "Auburn": "#782830",
    "Aurora": "#90b878",
    "Autumn Orange": "#e87820",
    "Avacado": "#788820",
    "Baby Blue": "#3098e0",
    "Baby Pink": "#f870c0",
    "Badlands Brown": "#382010",
    "Bahama Blue": "#40c8b8",
    "Bali Pink": "#e05080",
    "Bam Deep Burgundy": "#300808",
    "Bamboo": "#f0c080",
    "Banana": "#f0e840",
    "Banana Cream": "#f8b818",
    "Bang-Bang Jade": "#107868",
    "Bare Beauty": "#b85038",
    "Baroness": "#b08890",
    "Barrier Reef Blue": "#50c8d0",
    "Beige": "#d8b8b0",
    "Beige Rose": "#f0d8d0",
    "Beige Sienna": "#b08840",
    "Bermuda Blue": "#28a8c0",
    "Big Apple Red": "#980000",
    "Blonde": "#885838",
    "Blood": "#802820",
    "Blood Orange": "#f03018",
    "Blood Red": "#e03038",
    "Blue": "#1eacfd",
    "Blue Iris": "#5078d8",
    "Blue Purple Hue": "#000028",
    "Blue Sky": "#00a8e8",
    "Blue Slate": "#88b8e0",
    "Blue Violet Lake": "#4890d8",
    "Blush Pink": "#f89080",
    "Boca Blue": "#0050b0",
    "Bombay": "#e890d0",
    "Bora Bora Peach": "#e05038",
    "Bordeaux": "#401828",
    "Botticelli Brown": "#a86840",
    "Brick Red": "#881828",
    "Bright Coral": "#d85860",
    "Bright Green": "#007008",
    "Bright Orange": "#c85018",
    "Bright Red": "#e00000",
    "Bright Yellow": "#f8e028",
    "Brooklyn Brownstone": "#403828",
    "Brown": "#583030",
    "Brunette": "#604850",
    "Bubblegum": "#d05878",
    "Bubblegum Pink": "#f85888",
    "Bumble Bee Yellow": "#f0d838",
    "Burgundy": "#783030",
    "Burgundy Wine": "#380810",
    "Burnt Ochre": "#a03808",
    "Burnt Orange": "#984828",
    "Burnt Sienna": "#783828",
    "Burnt Umber 09": "#704840",
    "Butterscotch": "#a85018",
    "Cacao": "#382018",
    "Cadillac Pink": "#c880a8",
    "Cadmium Orange 04": "#f84800",
    "Cadmium Red Medium 05": "#d03050",
    "Cadmium Yellow Light 01": "#f8d800",
    "Cadmium Yellow Medium 02": "#f8a000",
    "Camel": "#985848",
    "Canary Yellow": "#f8f048",
    "Cancun Blue": "#008090",
    "Candy Red": "#f01820",
    "Cantaloupe": "#f8b070",
    "Caramel": "#985018",
    "Caribbean Sea": "#089078",
    "Carmine Red": "#f85048",
    "Carnation": "#f8a8b8",
    "Celadon": "#508070",
    "Celestial": "#58c8f0",
    "Chartreuse": "#68a018",
    "Cherry": "#d01848",
    "Cheshunt": "#783020",
    "Chestnut": "#504038",
    "China Blue": "#000858",
    "Chocolate": "#503818",
    "Cinnamon": "#b87068",
    "Clay Rose": "#603020",
    "Coco": "#786050",
    "Cocoa Bean": "#302018",
    "Coffee Brown": "#483028",
    "Cool Dark Grey": "#001820",
    "Cool Gray": "#384048",
    "Cool Light Grey": "#589098",
    "Cool Medium Grey": "#183040",
    "Cool Mint": "#30d8d0",
    "Copper": "#a04818",
    "Coral": "#f89060",
    "Coral Pink": "#f06870",
    "Corn": "#f0d070",
    "Cornflower": "#1890c0",
    "Cosmos": "#e8b8c0",
    "Cotton Candy": "#d858a8",
    "Country Blue": "#2090d0",
    "Cream Green": "#c0e0a8",
    "Cream Orange": "#e87830",
    "Crimson Lake": "#981810",
    "Crimson Red": "#b80800",
    "Cupcake Pink": "#f0b0b0",
    "Dahlia Purple": "#400828",
    "Dark Amber": "#e06838",
    "Dark Blood": "#802018",
    "Dark Blue": "#101858",
    "Dark Brown": "#783830",
    "Dark Chocolate": "#584840",
    "Dark Cobalt": "#001848",
    "Dark Flesh": "#c86858",
    "Dark Green": "#1a2716",
    "Dark Mahogany": "#806050",
    "Dark Ochre": "#c89830",
    "Dark Olive": "#584838",
    "Dark Purple": "#201030",
    "Dark Red": "#882038",
    "Dark-Magenta": "#381828",
    "Dark-Sangria": "#401828",
    "Darkest Brown": "#804848",
    "Darkest Chocolate": "#584840",
    "Dead Rose": "#a07880",
    "Dead Sea": "#98e0d8",
    "Deco Peach": "#f0b8a0",
    "Deco Pink": "#e8c0c8",
    "Deco Yellow": "#f8f080",
    "Decomposed Skin": "#200808",
    "Deep Blue": "#0028d8",
    "Deep Brown": "#705848",
    "Deep Burgundy": "#681820",
    "Deep Caribbean": "#386898",
    "Deep Cherry": "#883848",
    "Deep Green": "#1c2e3a",
    "Deep Pink": "#e83060",
    "Deep Purple": "#291f42",
    "Deep Purple (New)": "#282040",
    "Deep Red": "#502018",
    "Deep Violet": "#080818",
    "Denim Blue": "#000848",
    "Desert Dark": "#402018",
    "Desert Light": "#e05010",
    "Diablo": "#c02810",
    "Dirty Money": "#104030",
    "Dodger Blue": "#2888c0",
    "Dolphin": "#60a0a8",
    "Donatello Blue": "#0080c8",
    "Dragon": "#007868",
    "Dubai Gold": "#f8a808",
    "Dulce De Leche": "#804820",
    "Dusty Blue": "#206880",
    "Dusty Pink": "#a85060",
    "Dusty Rose": "#980038",
    "Ectoplasm": "#c8c868",
    "Einstein Blue": "#28a8e0",
    "El Dorado": "#e89808",
    "El Rojo": "#f00000",
    "Electric Blue": "#18a0c0",
    "Electric Raspberry": "#b00078",
    "Emerald": "#007878",
    "Enchanted Lilac": "#6848a0",
    "Equinox": "#a0d090",
    "Espresso": "#200800",
    "Everest Orange": "#f06010",
    "Everglades Green": "#286808",
    // Greywash strengths on their own, palest to darkest.
    "Extra Light": "#d9dbdd",
    "Light": "#b3b7ba",
    "Medium": "#85898d",
    "Dark": "#55585b",
    "Extra Dark": "#2b2d2f",
    "Faded Denim": "#0068a8",
    "Fan-Boy Orange": "#f85030",
    "Fire Coral": "#f88050",
    "Flame": "#d05038",
    "Flaming Pink": "#e82838",
    "Flaming Red": "#b81020",
    "Flesh": "#a06048",
    "Flying Pig": "#f07888",
    "Forest": "#182008",
    "Foundation Flesh": "#f8c888",
    "French Grey": "#808070",
    "Freshly Dead": "#986850",
    "Frost": "#a0c8c0",
    "Frostbite": "#608890",
    "Frosting Blue": "#90e0e0",
    "Fuchsia": "#c80058",
    "Fuschia": "#e058a8",
    "Galapagos Green": "#005868",
    "Galaxy Purple": "#6848b0",
    "Gamma-Green": "#00a000",
    "Gangrene": "#484800",
    "Georgia Peach": "#f08050",
    "Gingerbread": "#a08070",
    "Golden Brown": "#983828",
    "Golden Caramel": "#986850",
    "Golden Orange": "#f05820",
    "Golden Rod": "#f88000",
    "Golden Yellow": "#f89808",
    "Goldenrod": "#c88828",
    "Gradient Blue": "#00b8e0",
    "Graffiti Green": "#28a800",
    "Granny Smith Green": "#189000",
    "Grape": "#502860",
    "Grass Green": "#105010",
    "Graveside Dark": "#305070",
    "Graveside Light": "#402890",
    "Gray": "#67625e",
    "Great Wall Yellow": "#f0c018",
    "Green Beret": "#807018",
    "Green Concentrate": "#102820",
    "Green Day": "#78b838",
    "Green Slime": "#708020",
    "Greyed Lavender": "#9070a0",
    "Hada": "#d8b098",
    "Hard Orange": "#e04000",
    "Hazelnut": "#805838",
    "Heisenberg": "#58b8c8",
    "Henna": "#a81810",
    "Hollywood": "#025b81",
    "Hollywood Turquoise": "#005880",
    "Hone": "#d0b8a0",
    "Honey Dew": "#70b868",
    "Honey Yellow": "#f8c000",
    "Honey-Yellow": "#e9a93b",
    "Hoover Dam": "#403020",
    "Hot Chocolate": "#886060",
    "Hot Cocoa": "#986050",
    "Hot Mustard": "#d0a878",
    "Hunter Green": "#005038",
    "Hunter-Green": "#185050",
    "Icy-Blue": "#0098d8",
    "Imperial Red": "#d00808",
    "Imperial Violet": "#201060",
    "Incantation": "#c03810",
    "Indian Ink": "#885820",
    "Indigo Blue": "#000018",
    "Infected Skin": "#582000",
    "Irish Green": "#38c090",
    "Irish-Green": "#2e9e4f",
    "Ivory": "#e8a890",
    "Jade": "#489088",
    "Jasmine Purple": "#a0a0d0",
    "Jungle Green": "#104028",
    "Jupiter": "#f0b860",
    "Kaboom Gray": "#305078",
    "Kelp": "#384818",
    "Key Lime": "#98d018",
    "King Tut": "#c07050",
    "Kogecha": "#403018",
    "Kryptonite Green": "#40c818",
    "Kumetetsu": "#a85830",
    "LA Pink": "#e85858",
    "Lagoon": "#004038",
    "Lavender": "#b070b0",
    "Leaf Green": "#787818",
    "Leafy Green": "#186030",
    "Lemon Yellow": "#f0b000",
    "Liberaci Red": "#580828",
    "Light Aqua": "#00b0b0",
    "Light Brown": "#b88060",
    "Light Flesh": "#d09890",
    "Light Green": "#70c8a0",
    "Light Magenta": "#b00070",
    "Light Peach": "#f8d8b0",
    "Light Purple": "#8078c0",
    "Light Red": "#d02008",
    "Light Umber": "#604020",
    "Light-Red": "#e4525a",
    "Lightning yellow": "#f8d000",
    "Lilac": "#8848b0",
    "Lime Green": "#a0c040",
    "Lime Peel": "#809810",
    "Lime-Green": "#9acd32",
    "Lipstick Red": "#b80000",
    "Lite Green": "#709808",
    "Lollipop": "#c060a8",
    "Lollipop Purple": "#d8a8e0",
    "Magenta": "#f01030",
    "Mahogany": "#380808",
    "Majestic Purple": "#303860",
    "Malibu Pink": "#e01830",
    "Malibu-Pink": "#f58ab0",
    "Mandarin Orange": "#f87000",
    "Mango Yellow": "#e8a038",
    "Maple": "#a05838",
    "Mario's Blue": "#000050",
    "Mario's Light Blue": "#2870c0",
    "Mars Sand Red": "#d05848",
    "Matcha Green": "#c8c850",
    "Mauve": "#786060",
    "Medium Brown": "#783018",
    "Medium Coffee": "#382010",
    "Medium Green": "#186838",
    "Melon Red": "#e03830",
    "Mexican Rose": "#c83868",
    "Miami Blue": "#08a8b8",
    "Michelangelo Yellow": "#f8a800",
    "Mineral": "#d07028",
    "Mint": "#58c0b8",
    "Mint Green": "#30c058",
    "Mist": "#d0e0e0",
    "Mixing Yellow": "#f8d830",
    "Mocha": "#803810",
    "Mold": "#687038",
    "Mona Lisa Skin": "#c0a880",
    "Moon Dust": "#c0c090",
    "Moroccan": "#d83808",
    "Moss Green": "#b89808",
    "Mudslide": "#604838",
    "Mulberry": "#601010",
    "Mustard": "#a07020",
    "Muted Blue": "#002840",
    "Muted Green": "#082828",
    "Muted Purple": "#302018",
    "Muted Red": "#482010",
    "Muted Yellow": "#786830",
    "Napa Valley": "#680808",
    "Natto": "#b06038",
    "Natural Beige": "#f8c8a0",
    "Natural Skin": "#f0d8b8",
    "Navy Blue": "#182868",
    "Navy Seals Blue": "#003888",
    "Nebula": "#d080a0",
    "Nectar": "#e09068",
    "Neon": "#188818",
    "Neon Green": "#a6dd03",
    "Neon Yellow": "#d0d068",
    "Niagara Blue": "#0050a0",
    "Nice Blue": "#0060b8",
    "Nile River Blue": "#081860",
    "Non Photo Blue": "#4098d0",
    "Northern Lights Green": "#68b810",
    "Nova": "#a878b0",
    "Nuclear Green": "#78b000",
    "Nude": "#c89878",
    "Nude Blush": "#d07888",
    "Nugget": "#f8a000",
    "Nutella": "#282010",
    "Nutmeg": "#805858",
    "Ocean Dark": "#004868",
    "Ocean Light": "#30b0c0",
    "Ochre": "#c89050",
    "Off White": "#d8c090",
    "Old Orchid": "#381018",
    "Old Rose": "#783838",
    "Olive": "#384828",
    "Orange": "#f85030",
    "Orange Coral": "#d06058",
    "Orchid": "#a070b0",
    "Pale Flesh": "#d09070",
    "Pale Sage": "#98a048",
    "Pale Vermillion": "#f85828",
    "Panama Purple": "#8070b8",
    "Pancho Pastel Grey #1": "#90a0b0",
    "Pancho Pastel Grey #2": "#607080",
    "Pancho Pastel Grey #3": "#384858",
    "Pancho Pastel Grey #4": "#303840",
    "Papaya": "#c05858",
    "Paprika": "#b84028",
    "Paris Pink": "#d060b0",
    "Parma Violet": "#6030a8",
    "Parrot Green": "#109880",
    "Passion": "#d02020",
    "Pastel Blue": "#70c0e0",
    "Peach": "#e08088",
    "Peach Beige": "#d8c898",
    "Peach Orange": "#f89050",
    "Peachy": "#c89870",
    "Peachy Flesh": "#e8a078",
    "Peacock Blue": "#0058a8",
    "Peacock Green": "#083830",
    "Peanut": "#d8c8b8",
    "Pepto Pink": "#e81878",
    "Perfect Pink": "#b85060",
    "Periwinkle": "#1868b8",
    "Permanent Red": "#e03028",
    "Petroleum": "#183840",
    "Peyote": "#406868",
    "Phthalo Blue 08": "#303870",
    "Pink Coral": "#d05858",
    "Pink Floyd": "#c01048",
    "Pink Grapefruit": "#d08888",
    "Pink Panther": "#b84850",
    "Pink Rose": "#d89890",
    "Pistachio": "#d8d090",
    "Pitaya": "#d02070",
    "Plague Brown": "#b08048",
    "Plum": "#281008",
    "Pomegranate": "#701010",
    "Poppy Orange": "#f85820",
    "Poppy Red": "#e83830",
    "Porcelain Pink": "#e0d8d0",
    "Port Wine": "#401008",
    "Pow Orange": "#f86800",
    "Power Blue": "#182040",
    "Power brown": "#482828",
    "Power Red": "#e01818",
    "Power-Green": "#082028",
    "Pretty-Purple": "#9070d0",
    "Primrose": "#582848",
    "Prince Albert Pink": "#b06060",
    "Princess Pink": "#f06088",
    "Process Red": "#d03878",
    "Prussian Green": "#083010",
    "Pumpkin": "#d04820",
    "Pumpkin-Spice": "#f8a030",
    "Pure Blue": "#183078",
    "Pure Green": "#005068",
    "Pure Magenta": "#903058",
    "Pure Purple": "#002030",
    "Pure Turquoise": "#003860",
    "Purple": "#251f7c",
    "Purple Haze": "#604890",
    "Purple Heart": "#503890",
    "Putrid Brown": "#603830",
    "Radiant White": "#ffffff",
    "Rainbow Blue": "#20a8e0",
    "Rainforest": "#082028",
    "Rainforest Dark": "#083820",
    "Rainforest Light": "#70b058",
    "Raspberry": "#901810",
    "Real Black": "#100f14",
    "Really Red": "#d00020",
    "Red Cherry": "#800808",
    "Red Hot": "#a80808",
    "Red Plum": "#280808",
    "Red Violet": "#500858",
    "Reef Green": "#104840",
    "Revolution Blue": "#180850",
    "Rich Brown": "#985838",
    "Rich Dark Flesh": "#982000",
    "Rich Espresso": "#402820",
    "Rich Medium Flesh": "#a05020",
    "Rich Turquoise": "#004068",
    "Robin Egg": "#2088b8",
    "Robins Egg": "#3098a8",
    "Rodeo Red": "#d01808",
    "Rolls Royce Purple": "#984080",
    "Rose": "#c82830",
    "Rose Pink": "#f86060",
    "Rose Satin": "#f08080",
    "Rosy Beige": "#c89078",
    "Royal Blue": "#085088",
    "Royal Red": "#d85858",
    "Ruby Red": "#b00000",
    "Rust": "#903010",
    "Ryan Smith Snap Dragon": "#f05820",
    "Sable": "#483028",
    "Sage": "#688838",
    "Sahara": "#704020",
    "Sahara-Tan": "#d8c088",
    "Saigon Pink": "#d01858",
    "Sailor Jerry Red": "#b02018",
    "Salmon": "#f8b880",
    "Samuel O\u2019Reilly Red": "#b80020",
    "Sand": "#c8b8b0",
    "Sandstone": "#e8a868",
    "Sangria": "#900848",
    "Sap Green": "#487040",
    "Scarlet Red": "#e02838",
    "Scarlet-Red": "#d62232",
    "Sea Foam": "#40a078",
    "Sea Grape": "#684060",
    "Sea Shell": "#f87088",
    "Seal Brown": "#171819",
    "Seashell": "#a88858",
    "Sepia Dark": "#583810",
    "Sepia Light": "#a8a078",
    "Sepia Medium": "#906838",
    "Sepia Shade": "#403028",
    "Shamrock": "#008828",
    "Shark": "#68a898",
    "Ship Wreck": "#604860",
    "Sicilian Olive": "#806830",
    "Sidekick Purple": "#201030",
    "Sienna": "#a84800",
    "Sinatra Blue": "#98d8f0",
    "Skin Beige": "#d0b8a0",
    "Sky Blue": "#3070a8",
    "Slate Blue": "#5890e0",
    "Snail": "#c0a850",
    "Soft Orange": "#f85800",
    "Soft Red": "#a02820",
    "Solar Flare": "#f0e088",
    "Solid Gold": "#f0b800",
    "Solstice": "#70d0c8",
    "Southwest Blue": "#107098",
    "Spearmint": "#20a818",
    "Spearmint-Green": "#00c0b0",
    "Spice": "#c86840",
    "Spring Green": "#208038",
    "Sprinkle Pink": "#e890b8",
    "Steel": "#589098",
    "Steel Blue": "#48a0a8",
    "Stingray": "#505870",
    "Straight Red": "#b00808",
    "Strawberry": "#c82868",
    "Sunburst": "#f0d830",
    "Sunflower": "#f8b828",
    "Sunset Blvd": "#f85808",
    "Sunshine": "#b88860",
    "Sunstroke": "#e8b050",
    "Super Red": "#902828",
    "Super White": "#fbf8f5",
    "Superhero Red": "#d82020",
    "Swiss Skin": "#d8b090",
    "Tahitian Teal": "#0090a0",
    "Taj Mahal": "#b89880",
    "Tan": "#f0a888",
    "Tangelo": "#f02820",
    "Tangerine": "#f87050",
    "Teal": "#28b8a0",
    "Tejas Tan": "#885028",
    "Tequila Sunrise": "#f85850",
    "Terra": "#887058",
    "Terracotta": "#984040",
    "Thomas Carli Jarlier Noire Wash": "#081830",
    "Thunder Violet": "#6058b0",
    "Tiffany": "#20d0c0",
    "Tiger": "#884800",
    "Tiger Orange": "#f85010",
    "Tribal Black": "#0c0d0f",
    "Tropical Teal": "#185858",
    "True Blood Red": "#802028",
    "True Blue": "#002880",
    "True Gold": "#f87828",
    "True Green": "#28a048",
    "Turbo Black": "#0c0d0f",
    "Turquoise": "#083848",
    "Turquoise Concentrate": "#001818",
    "Turquoise-Concentrate": "#102030",
    "Twilight": "#a090b0",
    "Tyrian Purple": "#901848",
    "Ultramarine": "#181048",
    "Ultramarine Blue 07": "#303870",
    "Undead Red": "#480800",
    "Van Gogh Tan": "#a86850",
    "Vanilla": "#e8d890",
    "Vanilla Yellow": "#f0d890",
    "Vegas Green": "#084020",
    "Velvet Purple": "#9898e8",
    "Venice": "#986030",
    "Victorian Rose (formerly Flesh Tone)": "#d07870",
    "Villain Green": "#686830",
    "Vintage Wine": "#582018",
    "Violet": "#180860",
    "Violet Blue": "#080860",
    "Warm Dark Grey": "#200820",
    "Watermelon": "#a82830",
    "Wham Dark-Flesh": "#983010",
    "Wham-Tan": "#d88848",
    "Wild Lavender": "#80a0c0",
    "Wild Orchid": "#282030",
    "Wildflower": "#607088",
    "Will's Olive": "#789038",
    "Wine": "#781030",
    "Wine Berry": "#483868",
    "Wine Red": "#b82848",
    "Wineberry": "#401030",
    "Woodlands Dark": "#303820",
    "Woodlands Light": "#708000",
    "Wow-Yellow": "#f8d020",
    "Yellow Jacket": "#f8c000",
    "Yellow Ochre": "#b89040",
    "Yellow Ochre 03": "#d8a048",
    "Yellow-Ochre": "#f0a800",
    "Yellowed Orange": "#e8a820",
    "Yellowstone": "#f8f098",
    "Yerba": "#585840",
    "Zero Gravity": "#b898d0",
    "Zing Violet Red": "#503068",
  };

  /*
    Every other colour name in the shop. The ink sets above are matched exactly;
    these are single words looked for inside a name, so "Bumble Bee Yellow",
    "Sunflower" and "Deep Sea Blue" all find a colour to show. Words like
    "light", "deep" and "bright" then lighten or darken it a little.

    TO EDIT: change a hex here and every name containing that word follows.
  */
  var WORD_COLOURS = {
    // Blacks, greys and whites
    white: '#f7f5f2',
    black: '#111111',
    grey: '#8b8f93',
    gray: '#8b8f93',
    greywash: '#8b8f93',
    silver: '#c4c8cc',
    charcoal: '#3a3f43',
    slate: '#6a7b8a',
    ash: '#a8a49e',
    smoke: '#9a9a96',
    graphite: '#4a4f54',
    steel: '#7d8a95',
    platinum: '#d8dade',
    onyx: '#0e0e10',
    ebony: '#25211e',
    ink: '#14161a',
    noire: '#1a1a1c',
    shadow: '#3c3f45',
    pearl: '#f2ece4',
    frost: '#e6eef2',
    mist: '#d7dee0',
    stone: '#9a958c',
    sandstone: '#cfae82',
    pencil: '#5a5f63',
    metal: '#9aa3ab',
    mineral: '#8f9aa0',
    chrome: '#c9d0d6',
    gunmetal: '#4b5157',
    shark: '#6f7a80',
    stingray: '#7a8288',
    dolphin: '#7d97a8',
    crystal: '#e9f1f4',
    clear: '#eef2f4',
    seashell: '#f4ece2',
    // Reds
    red: '#c8102e',
    rojo: '#c8102e',
    crimson: '#b3122e',
    scarlet: '#d0212b',
    ruby: '#a1102b',
    cherry: '#c8102e',
    blood: '#7c0d16',
    maroon: '#6b1220',
    burgundy: '#6b0f26',
    wine: '#5e1327',
    whine: '#5e1327',
    sangria: '#6e1024',
    bordeaux: '#5c1024',
    brick: '#a63a2a',
    tomato: '#d4402c',
    chilli: '#c0281f',
    chili: '#c0281f',
    strawberry: '#d6294a',
    pomegranate: '#9e1f34',
    vermillion: '#e34234',
    vermilion: '#e34234',
    lava: '#d0361c',
    flame: '#e64a19',
    fire: '#e0431f',
    firecracker: '#e0431f',
    rust: '#a8442a',
    watermelon: '#e34f5a',
    diablo: '#a8121f',
    // Pinks
    pink: '#f06fa5',
    rose: '#e07a94',
    blush: '#f2b8bf',
    magenta: '#d4177f',
    fuchsia: '#d9218c',
    fuschia: '#d9218c',
    bubblegum: '#f26ea6',
    carnation: '#f56a94',
    flamingo: '#f2809a',
    raspberry: '#c2245a',
    razzleberry: '#b83a6e',
    peony: '#e878a0',
    lipstick: '#c41e46',
    salmon: '#f08a7a',
    coral: '#f4785e',
    sakura: '#f6c1cf',
    momo: '#f4b6c2',
    pitaya: '#e0417a',
    lollipop: '#ef5d8f',
    primrose: '#f2c6d8',
    // Purples
    purple: '#6b2fa0',
    violet: '#5a2aa0',
    lavender: '#b5a0d8',
    lilac: '#c3a4d8',
    plum: '#6b2a52',
    grape: '#6b2fa0',
    amethyst: '#8a5bbd',
    orchid: '#b45fc4',
    mulberry: '#7a2350',
    berry: '#8e2358',
    blueberry: '#4a4a8c',
    huckleberry: '#5b3a6e',
    indigo: '#3b2a8c',
    mauve: '#a37f9e',
    wineberry: '#3f1432',
    periwinkle: '#8f9fe0',
    vampy: '#4a1030',
    // Blues
    blue: '#1f5fcb',
    navy: '#12235c',
    cobalt: '#1948b3',
    sapphire: '#1a4b9c',
    azure: '#1e7fd4',
    sky: '#6fb7f0',
    teal: '#1f9c9c',
    turquoise: '#2ec4c0',
    aqua: '#4fd5c4',
    aquamarine: '#4fd5c4',
    cyan: '#22c0e8',
    ultramarine: '#2432a8',
    denim: '#3c5a86',
    ocean: '#1f6a94',
    lagoon: '#1f9aa8',
    sea: '#2a7f9e',
    caribbean: '#22a9b8',
    atlantis: '#2a8fa8',
    cornflower: '#6d8ee0',
    celestial: '#6fa8dc',
    zircon: '#4fb8d8',
    topaz: '#3fa9c9',
    tiffany: '#7ad0cd',
    petroleum: '#1f4a55',
    // Greens
    green: '#2e8b45',
    emerald: '#0f9d58',
    jade: '#2fa07a',
    mint: '#7fd6b0',
    olive: '#6b7a2e',
    lime: '#8fce2a',
    forest: '#1e5b32',
    rainforest: '#1f6b3a',
    woodlands: '#3f6b3a',
    leaf: '#4a9a3a',
    moss: '#5c7a3a',
    sage: '#9aa87f',
    seafoam: '#8fd8bc',
    shamrock: '#20a44f',
    algae: '#5f8a3a',
    kelp: '#40603a',
    pistachio: '#a8cf7a',
    avocado: '#6f8a3c',
    artichoke: '#7a8a5a',
    chartreuse: '#b7d32a',
    celadon: '#a6c9a2',
    agave: '#7fa07a',
    midori: '#3fae6a',
    yerba: '#5f7a3a',
    bamboo: '#a8c25a',
    fig: '#5a6b3a',
    mold: '#6f7a45',
    // Yellows and golds
    yellow: '#ffe01b',
    gold: '#d4a017',
    golden: '#e0aa1e',
    goldenrod: '#dba00f',
    nugget: '#d9a52a',
    amber: '#e39b18',
    mustard: '#d1a428',
    lemon: '#f6e36a',
    banana: '#f5e06b',
    canary: '#f7e34a',
    corn: '#f5ce4a',
    sunflower: '#f2c116',
    sunshine: '#ffd93b',
    sunburst: '#f7c13a',
    honey: '#e0a53a',
    butterscotch: '#d99a3a',
    cheddar: '#e08a2a',
    champagne: '#eddfbb',
    minion: '#f5d63a',
    natto: '#d8c88a',
    // Oranges
    orange: '#f97316',
    tangerine: '#f37a1f',
    tangelo: '#f2731a',
    apricot: '#f2a86a',
    peach: '#f7bd94',
    peachy: '#f7bd94',
    pumpkin: '#e2711d',
    papaya: '#f4924a',
    cantaloupe: '#f7a35c',
    nectar: '#f0a352',
    marigold: '#f0a01c',
    dreamsicle: '#f7a878',
    paprika: '#b23a1e',
    sahara: '#dda45c',
    // Browns
    brown: '#6b4326',
    brownstone: '#6b4326',
    earthbrown: '#6b4326',
    chocolate: '#4a2c1a',
    cocoa: '#5a3a24',
    cacao: '#4e3220',
    coffee: '#5a3a24',
    espresso: '#3a251a',
    mocha: '#6b4a35',
    caramel: '#c08a54',
    coco: '#7a5236',
    camel: '#c08a54',
    chestnut: '#7a4326',
    hazelnut: '#a9714b',
    walnut: '#6b4a30',
    mahogany: '#63301f',
    auburn: '#8a3d24',
    sienna: '#a0522d',
    umber: '#5f4632',
    sepia: '#6b4f36',
    tan: '#c49a6c',
    taupe: '#a89684',
    henna: '#9c4a26',
    tobacco: '#6b4a2a',
    nutmeg: '#7a4a2e',
    nutella: '#7a4a2e',
    cinnamon: '#9c5a2a',
    cinnamoney: '#9c5a2a',
    gingerbread: '#8a4f2a',
    peanut: '#c39a68',
    almond: '#e0c3a0',
    khaki: '#b3a06a',
    copper: '#b76e3b',
    bronze: '#a5722f',
    ochre: '#c9821c',
    ocher: '#c9821c',
    dune: '#cdb894',
    clay: '#b07a5a',
    terracotta: '#c66a4a',
    terra: '#b5643f',
    fudge: '#4a2f1e',
    pudding: '#c8a06a',
    maple: '#a5652c',
    roast: '#4a3222',
    kogecha: '#4a3a2a',
    // Creams and skin tones
    cream: '#f5e9d6',
    ivory: '#f5efe2',
    bone: '#e8dfd0',
    vanilla: '#f3e5c0',
    wheat: '#e0c894',
    beige: '#e2cfb4',
    sand: '#dcc39a',
    nude: '#e2b79a',
    flesh: '#e8b48f',
    skin: '#e0b090',
    hada: '#e8bfa0',
    blonde: '#dcb87a',
    brunette: '#5a3a26',
    // A few names that are a colour in all but word
    candy: '#f48fb1',
    avocado: '#6f8a3c',
    avacado: '#6f8a3c',
    mudslide: '#6b4a35',
    dorado: '#d4a017',
    sunrise: '#f2913a',
    sunstroke: '#f2a03a',
    pineapple: '#f2d14a',
    peyote: '#7a9a6a',
    foam: '#8fd8bc',
    mermaid: '#2fa79a',
    tiger: '#e2711d',
    dragon: '#b3122e',
    phantom: '#4a4a52',
    venice: '#3f6a8a',
    moroccan: '#b5643f',
    mochi: '#f2e2d8',
    yellowstone: '#d9a52a',
    autumn: '#c06a2a',
    robin: '#6fc9c0',
  };

  /* Words that make the colour paler or deeper. */
  var LIGHTEN = {
    light: 0.28,
    pale: 0.34,
    soft: 0.24,
    baby: 0.3,
    pastel: 0.34,
    faded: 0.26,
    washed: 0.3,
    wash: 0.3,
    dusty: 0.2,
    sun: 0.14,
    blooming: 0.2,
  };

  var DARKEN = {
    dark: 0.28,
    darker: 0.4,
    darkest: 0.52,
    deep: 0.28,
    midnight: 0.45,
    night: 0.4,
    shade: 0.2,
    shading: 0.2,
    burnt: 0.24,
    dirty: 0.2,
    cold: 0.1,
  };

  /* Words that make it stronger rather than lighter or darker. */
  var STRONGER = ['bright', 'vivid', 'electric', 'neon', 'hot', 'flaming', 'blazing', 'atomic', 'super'];

  function normalise(value) {
    return String(value).toLowerCase().replace(/[\s\-_]+/g, '');
  }

  var swatches = {};
  Object.keys(INK_COLOURS).forEach(function (name) {
    swatches[normalise(name)] = INK_COLOURS[name];
  });


  /* ---------- Working out a colour from its name ---------- */

  function toRgb(hex) {
    var value = String(hex).replace('#', '');
    return [
      parseInt(value.slice(0, 2), 16),
      parseInt(value.slice(2, 4), 16),
      parseInt(value.slice(4, 6), 16),
    ];
  }

  function toHex(parts) {
    return (
      '#' +
      parts
        .map(function (part) {
          var whole = Math.round(Math.min(255, Math.max(0, part)));
          return (whole < 16 ? '0' : '') + whole.toString(16);
        })
        .join('')
    );
  }

  /* Blend a colour towards white or black. */
  function mix(hex, towards, amount) {
    var from = toRgb(hex);
    var to = toRgb(towards);
    return toHex(
      from.map(function (part, index) {
        return part + (to[index] - part) * amount;
      })
    );
  }

  /* Push a colour away from grey, for names like "Bright" and "Electric". */
  function punchier(hex) {
    var parts = toRgb(hex);
    var average = (parts[0] + parts[1] + parts[2]) / 3;
    return toHex(
      parts.map(function (part) {
        return part + (part - average) * 0.35;
      })
    );
  }

  /*
    Colours we have no exact hex for. Look for a colour word inside the name -
    the last one, since the colour usually comes last ("Bumble Bee Yellow") -
    then lighten or deepen it for words like "light", "deep" and "bright".
    A name with no colour word in it at all keeps the plain grey dot.
  */
  function guessSwatch(value) {
    var name = String(value).toLowerCase();

    // Greywash strengths: "10%" is a whisper of grey, "90%" is nearly black.
    // Some sets write them as bare numbers ("20", "40") instead.
    var wash = name.match(/^(\d{1,3})\s*%?$/);
    if (wash) {
      var strength = Math.min(100, Math.max(5, parseInt(wash[1], 10))) / 100;
      return mix('#111111', '#ffffff', 1 - strength * 0.92);
    }

    var words = name.split(/[^a-z]+/).filter(Boolean);
    var base = null;
    var lighter = 0;
    var darker = 0;
    var strong = false;

    for (var i = words.length - 1; i >= 0; i--) {
      var word = words[i];
      // "Berries" and "Reds" are the same colour as "Berry" and "Red".
      if (!WORD_COLOURS[word] && word.slice(-3) === 'ies') word = word.slice(0, -3) + 'y';
      else if (!WORD_COLOURS[word] && word.slice(-1) === 's') word = word.slice(0, -1);
      if (!base && WORD_COLOURS[word]) base = WORD_COLOURS[word];
      // Colours stuck onto the front or back of a word, as in "Spearmint".
      if (!base) base = insideWord(word);
      if (LIGHTEN[word]) lighter = Math.max(lighter, LIGHTEN[word]);
      if (DARKEN[word]) darker = Math.max(darker, DARKEN[word]);
      if (STRONGER.indexOf(word) !== -1) strong = true;
    }

    // "Light", "Medium", "Extra Dark" on their own are greywash strengths.
    if (!base && (lighter || darker || words.indexOf('medium') !== -1)) base = WORD_COLOURS.grey;
    if (!base) return null;

    if (strong) base = punchier(base);
    if (lighter) base = mix(base, '#ffffff', lighter);
    if (darker) base = mix(base, '#000000', darker);
    return base;
  }

  /*
    A colour word joined onto another word - "Spearmint", "Brownie". Only whole
    colour words of four letters or more, at the start or the end, so a word
    like "Sundried" is not read as red.
  */
  function insideWord(word) {
    if (word.length < 6) return null;
    var found = null;
    Object.keys(WORD_COLOURS).forEach(function (colour) {
      if (found || colour.length < 4 || colour.length >= word.length) return;
      if (word.indexOf(colour) === 0 || word.slice(-colour.length) === colour) {
        found = WORD_COLOURS[colour];
      }
    });
    return found;
  }

  function swatchFor(value) {
    if (!value) return null;
    return swatches[normalise(value)] || guessSwatch(value);
  }

  /*
    Names that mean "more than one colour" - a set of assorted bottles, say.
    There is no single colour to show, so the dot is a rainbow instead of the
    plain grey stripes we use for a name we do not recognise.
  */
  var MIXED_NAMES = ['mixed', 'mixedcolours', 'mixedcolors', 'multi', 'multicolour', 'multicolor', 'multicoloured', 'multicolored', 'assorted', 'rainbow', 'various'];

  function isMixed(value) {
    return MIXED_NAMES.indexOf(normalise(value)) !== -1;
  }

  window.MagnumColours = {
    hexFor: swatchFor,
    isMixed: isMixed,
    normalise: normalise,
  };
})();
